var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#ECB244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49152 11.1634H12.0336V13.0477H9.85389C9.88989 13.5866 9.90845 14.0867 9.94445 14.625H8.11014V13.0669H5.92989C5.92989 12.4521 5.85733 11.8367 5.96645 11.2596C6.02102 10.9519 6.34783 10.6824 6.54752 10.4136C7.2384 9.55019 7.93479 8.69124 8.63664 7.83675C8.90945 7.50938 9.1817 7.20169 9.49052 6.83663H6.09302V4.95225H8.11014V3.375H9.87189V4.91344H12.0701C12.0701 5.54794 12.1427 6.16331 12.0336 6.74044C11.979 7.04812 11.6522 7.31756 11.4345 7.58644C10.7436 8.44981 10.0472 9.30876 9.34539 10.1633C9.07135 10.5055 8.78658 10.8391 8.49152 11.1634Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZec);
export default __webpack_public_path__ + "static/media/zec.41b7642c7dd1a43ee4cd187c59ac3ac1.svg";
export { ForwardRef as ReactComponent };